import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { State } from '../../store/auth/auth.reducer';
import * as fromAuth from '../../store/auth';
import { NgxSpinnerService } from 'ngx-spinner';
import { filter, takeUntil, tap } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import * as fromRouting from "../../../core/store/routing";
import { SystemNotificationsService } from '@app/core/system-notifications/system-notifications.service';

@Component({
    selector: 'topo-dashboard-link',
    templateUrl: './dashboard-link.component.html',
    styleUrls: ['./dashboard-link.component.scss'],
    standalone: false
})
export class DashboardLinkComponent implements OnInit, OnDestroy {
  code: string;
  destroy$ = new Subject<void>();
  errorMessage$: Observable<string>;
  error: boolean;

  constructor(
    private activatedRoute: ActivatedRoute,
    private store: Store<State>,
    private spinnerService: NgxSpinnerService,
    private notify: SystemNotificationsService,
    private translateService: TranslateService) { }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete()
  }

  ngOnInit(): void {
    this.error = false;
    this.errorMessage$ = this.store.select(fromAuth.selectDashboardLinkError);

    this.activatedRoute.queryParams.subscribe(params => {
      this.code = decodeURI(params['code']);
      this.store.dispatch(fromAuth.sharedDashboardAuthWorking({ isWorking: true }));
      this.store.dispatch(fromAuth.routeToSharedDashboard({ sharedCode: this.code }));
    });

    this.store.select(fromAuth.selectIsSharedDashboardWorking)
    .pipe(
      tap(isWorking => {
        isWorking ? this.spinnerService.show() : this.spinnerService.hide();
      }),
      takeUntil(this.destroy$)
    )
    .subscribe();

    this.errorMessage$
      .pipe(
        filter(err => !!err),
        tap(value => {
          this.spinnerService.hide();
          this.error = true;

          if (value == "IP_ADDRESS_IS_RESRICTED") {
            this.store.dispatch(
              fromRouting.go({
                routeData: { path: ['login/ip-restricted'] }
              })
            );
          }
          else {
            value = `ERRORS.${value}`;
            this.translateService.get(value).subscribe(res => {
              this.notify.error(res);
            });
          }
        }),
        takeUntil(this.destroy$)
      )
      .subscribe();
  }
}
